export default __webpack_public_path__ + "static/media/09.024b930b.jpg";